import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function LogoutPage() {
  const navigate = useNavigate();

  const onLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <Link to="/login" onClick={onLogout} className="dropdown-item ai-icon">
      <svg
        className="text-primary me-1"
        width={18}
        height={18}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
        <polyline points="16 17 21 12 16 7"></polyline>
        <line x1="21" y1="12" x2="9" y2="12"></line>
      </svg>
      <span className="ms-2">Logout</span>
    </Link>
  );
}

export default LogoutPage;
